import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
  SxProps,
  Theme
} from "@mui/material";

/**
 * DefaultInput
 */

interface Props {
  name: string,
  icon?: React.ReactNode | null,
  helperText?: string,
  value?: string | null,
  multiline?: boolean,
  rows?: number,
  maxRows?: number,
  readOnly?: boolean,
  sx?: SxProps<Theme>,
  onBlur?: () => void,
  onChangeValue?: (value: string) => void,
}

function DefaultInput({
  name,
  label,
  icon,
  error,
  helperText,
  value,
  multiline,
  rows,
  maxRows,
  readOnly,
  sx,
  onBlur,
  onChangeValue,
  ...props
}: Props & OutlinedInputProps) {
  const handleClickShowPassword = () => { };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  };

  return (
    <FormControl sx={{ width: '100%', ...sx }} variant="outlined" size="small">
      <InputLabel
        htmlFor={`input-${name}`}
        required={props.required}
        error={error}>
        {label}
      </InputLabel>

      {
        icon ?
          <OutlinedInput
            id={`input-${name}`}
            label={label}
            error={error}
            size="small"
            aria-describedby="component-error-text"
            fullWidth={true}
            readOnly={readOnly}
            onBlur={onBlur}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end">
                  {icon}
                </IconButton>
              </InputAdornment>
            }
            multiline={multiline}
            rows={rows}
            maxRows={maxRows}
            value={value ?? ""}
            onChange={(e) => onChangeValue?.(e.target.value)}
            onKeyDown={(event) => event.stopPropagation()}
          /> : <OutlinedInput
            id={`input-${name}`}
            label={label}
            error={error}
            size="small"
            aria-describedby="component-error-text"
            fullWidth={true}
            readOnly={readOnly}
            onBlur={onBlur}
            value={value ?? ""}
            multiline={multiline}
            rows={rows}
            maxRows={maxRows}
            onChange={(e) => onChangeValue?.(e.target.value)}
            onKeyDown={(event) => event.stopPropagation()}
          />
      }

      <FormHelperText id="component-error-text" error>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}

export default DefaultInput;